<template>
    <form
        class="flex flex-col gap-4"
        @submit="onSubmit"
    >
        <span class="font-header text-lg font-medium">Edit pickup address</span>
        <LockedEditingBanner v-if="sessionStore.isLocked" />
        <fieldset
            :disabled="sessionStore.isLocked"
            :inert="sessionStore.isLocked || undefined"
            class="min-w-0"
            :class="{ 'cursor-not-allowed opacity-50': sessionStore.isLocked }"
        >
            <MuvalAddress
                vid="move.pickup_address"
                @update:placeId="pickupPlaceId = $event"
            />
        </fieldset>

        <div class="ml-auto flex gap-4">
            <MuvalButton
                borderless
                tertiary
                @click.prevent="closePickupAddressDialog"
            >
                Cancel
            </MuvalButton>
            <MuvalButton
                type="submit"
                primary
                alternate
                :disabled="isLoading || sessionStore.isLocked"
                :loading="isLoading"
            >
                Save
            </MuvalButton>
        </div>
    </form>
</template>

<script setup>
import { useForm } from 'vee-validate';
import { useSessionStore, useResultsStore } from '@/store';
import { closePickupAddressDialog } from '@/composables/dialog';

const sessionStore = useSessionStore();
const initialValues = ref({
    move: {
        pickup_address: sessionStore.getPrimaryProduct.pickup_address,
    },
});

const form = useForm({
    initialValues: initialValues.value,
});

const router = useRouter();
const isLoading = ref(false);
const pickupPlaceId = ref(null);
const onSubmit = form.handleSubmit(async (values) => {
    isLoading.value = true;
    await window.axios.patch(`/customers/book/move/${sessionStore.getMoveId}/pickup/details`, {
        ...values,
        move: {
            ...values.move,
            pickup_address_place_id: pickupPlaceId.value,
        },
    });

    await sessionStore.retrieve();

    const results = useResultsStore();
    try {
        if (sessionStore.isLocal) {
            results.startRange = null;
            results.endRange = null;
            results.direction = null;
            await results.refetchPricing();
        } else {
            // fetch matches
            await results.prefetch();
        }
    } catch (error) {
        console.error('Failed to update results store:', error);
    } finally {
        isLoading.value = false;
    }

    if (sessionStore.hasReachedResults) {
        router.replace({ name: 'Loading' });
    }

    closePickupAddressDialog();
    isLoading.value = false;
});
</script>
